import Head from 'next/head';
import Header from '../../components/Header';
import Hero from '../../components/Hero';
import Services from '../../components/Services';
import SocialProof from '../../components/SocialProof';
import ContactUs from '../../components/ContactUs';
import Footer from '../../components/Footer';
import { generateServiceSchema } from '../../utils/generateServiceSchema';
import { generateWebPageSchema } from '../../utils/generateWebPageSchema';

export default function ServicesPage() {

  const service = {
    title: 'General Contractor Services',
    image: '/hero/best-home-remodeling-and-construction-services-in-los-angeles.webp',
    description:
      'Explore Modern Build’s expert remodeling in Los Angeles kitchens, baths, ADUs, roofing & more. Free estimate: (323) 300-4130',
    link: '/services',
  };

  const base = 'https://modernbuildremodel.com';
  const pageUrl = `${base}${service.link}`;

  const serviceSchema = generateServiceSchema(service, pageUrl);


  // Breadcrumb JSON-LD
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://modernbuildremodel.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Services",
        "item": `${pageUrl}`
      }
    ]
  };

  return (
    <>
      <Head>
        <title>Our Remodeling Services | Free Estimate | Modern Build</title>
        <meta name="title" content="Our Remodeling Services | Free Estimate | Modern Build" />
        <meta name="description" content="Explore Modern Build’s expert remodeling in Los Angeles kitchens, baths, ADUs, roofing & more. Free estimate: (323) 300-4130" />
        <meta name="keywords" content="remodeling services, home renovation, kitchen remodeling, bathroom remodeling, roofing, ADU conversion, Los Angeles construction, Modern Build" />
        <meta name="author" content="Modern Build Home Remodeling" />

        {/* Canonical URL to avoid duplicate content issues */}
        <link rel="canonical" href="https://modernbuildremodel.com/services" />

        {/* Open Graph Meta Tags for social sharing */}
        <meta property="og:title" content="Our Remodeling Services | Free Estimate | Modern Build" />
        <meta property="og:description" content="Explore Modern Build’s expert remodeling in Los Angeles kitchens, baths, ADUs, roofing & more. Free estimate: (323) 300-4130" />
        <meta property="og:image" content="https://modernbuildremodel.com/hero/best-home-remodeling-and-construction-services-in-los-angeles.webp" />
        <meta property="og:url" content="https://modernbuildremodel.com/services" />
        <meta property="og:site_name" content="Modern Build Home Remodeling" />
        <meta property="og:type" content="website" />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Our Remodeling Services | Free Estimate | Modern Build" />
        <meta name="twitter:description" content="Explore Modern Build’s expert remodeling in Los Angeles kitchens, baths, ADUs, roofing & more. Free estimate: (323) 300-4130" />
        <meta name="twitter:image" content="https://modernbuildremodel.com/hero/best-home-remodeling-and-construction-services-in-los-angeles.webp" />
        <meta name="twitter:site" content="@modernbuildhome" />
       
        {/* JSON-LD Structured Data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(generateWebPageSchema({
            title: 'Home Remodeling Services | Free Estimate | Modern Build',
            description: 'Browse all remodeling services offered by Modern Build including kitchens, bathrooms, garages, and more.',
            slug: '/services'
          })) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
        />
      </Head>

      <Header />
      <Hero category="services" page="page" hasContentH1={false}/>
      <Services category="services" />
      <SocialProof />
      <ContactUs />
      <Footer />
    </>
  );
}
